const PasswordHelper = {
  passwordMinLength() {
    return 8
  },

  passwordHasMinCharacters(password) {
    return password?.length >= this.passwordMinLength()
  },

  passwordHasNumber(password) {
    return /^(?=.*[0-9])/.test(password)
  },

  passwordHasUpperCase(password) {
    return /^(?=.*[A-Z])/.test(password)
  },

  passwordHasLowerCase(password) {
    return /^(?=.*[a-z])/.test(password)
  },

  passwordHasNoLeadingOrTrailingWhitespace(password) {
    return !/^\s+|\s+$/.test(password)
  },

  passwordHasSpecialCharacter(password) {
    // Ensures any regex special characters are escaped!
    const escapedSpecialCharsPattern = this.allowedSpecialChars().map((char) =>
      char.replace(/[.*+^?\-[\](){}\\]/g, '\\$&')
    )
    return new RegExp(`[${escapedSpecialCharsPattern.join('')}]`).test(password)
  },

  allowedSpecialChars() {
    return ['^', '$', '*', '!', '@', '#', '%', '&']
  },

  passwordRules() {
    return [
      (v) => !!v || 'Password is required',
      (v) =>
        (this.passwordHasMinCharacters(v) &&
          this.passwordHasLowerCase(v) &&
          this.passwordHasUpperCase(v) &&
          this.passwordHasNumber(v) &&
          this.passwordHasNoLeadingOrTrailingWhitespace(v) &&
          this.passwordHasSpecialCharacter(v)) ||
        'Invalid Password'
    ]
  },

  passwordsMatchRule(password, confirmPassword) {
    return password === confirmPassword || 'Passwords must match!'
  },

  passwordNotSameAsCurrentRule(currentPassword, newPassword) {
    return (
      currentPassword !== newPassword ||
      'New Password must not be the same as current password'
    )
  }
}

export default PasswordHelper
